<template>
    <div id="app" class="w-screen h-full text-gray-900 bg-box-whitemode">
        <Layout class="safe-area-inset-bottom w-full h-full bg-white">
            <router-view :key="viewKey" class="w-full h-full"/>
        </Layout>
    </div>
</template>

<script>
    import { Layout } from '@/layouts';
    import bus from '@/utils/event-bus.js';
    import { state, actions } from "@/store";

    export default {
        name: 'App',
        components: {
            Layout
        },
        data() {
            return {
                viewKey: 1
            };
        },
        methods: {
            updateViewKey() {
                this.viewKey += 1;
            }
        },
        computed: {
            user() {
                return state.user;
            },
            role() {
                return state.user.rol.Name;
            },
            relation() {
                return this.user.relation;
            }
        },
        mounted() {
            bus.$on('layout:refresh', () => {
                console.log('refreshing madafacka');
                this.updateViewKey();
            });
        }
    };
</script>

<style>
    .no-scrollbar::-webkit-scrollbar {
        width: 0px;
    }
</style>
